import "./page-title.less";
export default function PageTitle() {
    return {
        restrict: "E",
        scope: {
            title: "=",
        },
        replace: false,
        template: require("./page-title.html"),

        controller: function ($scope) {
            var setPageTitleEventListener = $scope.$on(
                "set-page-title",
                function (event, pageTitle) {
                    // console.log(pageTitle.title + " scope");
                    $scope.title = pageTitle.title;
                }
            );
            $scope.$on("$destroy", setPageTitleEventListener);
        },
    };
}
